import { render } from "./NewsFormModal.vue?vue&type=template&id=6b36fefe&scoped=true"
import script from "./NewsFormModal.vue?vue&type=script&lang=js"
export * from "./NewsFormModal.vue?vue&type=script&lang=js"

import "./NewsFormModal.vue?vue&type=style&index=0&id=6b36fefe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b36fefe"

export default script